import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { formatDate, formatMoney, regexPhoneNumber } from 'helpers/helpers'

import logo from 'assets/images/logo.png'

function toNumber(value) {
	return Number(value ?? 0) || 0
}

function isPreparedProduct(product) {
	return product?.is_prepared === true || product?.is_prepared === 1 || product?.is_prepared === '1'
}

function isMetrReturnProduct(product) {
	const productType = Number(product?.product_type ?? product?.product_type_id)
	return [3, 4, 5].includes(productType) && !isPreparedProduct(product)
}

function getReturnQuantity(product) {
	if (isMetrReturnProduct(product)) {
		return toNumber(product?.metr || product?.quantity)
	}

	return toNumber(product?.quantity)
}

function getPrintProduct(product) {
	const returnQuantity = getReturnQuantity(product)
	const returnedQuantity = Math.min(toNumber(product.original_returned_quantity), returnQuantity)
	const remainingQuantity = product.remaining_quantity !== undefined
		? toNumber(product.remaining_quantity)
		: Math.max(returnQuantity - returnedQuantity, 0)
	const quantityRatio = returnQuantity > 0 ? remainingQuantity / returnQuantity : 0
	const printRollQuantity = isMetrReturnProduct(product)
		? toNumber(product.quantity) * quantityRatio
		: remainingQuantity
	const returnedAmount = product.returned_amount !== undefined
		? toNumber(product.returned_amount)
		: returnedQuantity * toNumber(product.sale_price)
	const totalPrice = product.net_total_price !== undefined
		? toNumber(product.net_total_price)
		: Math.max(toNumber(product.total_price) - returnedAmount, 0)
	const originalSqM = toNumber(product.roll_metr) * toNumber(product.length)
	const sqM = returnQuantity > 0 ? originalSqM * (remainingQuantity / returnQuantity) : 0

	return {
		...product,
		print_quantity: remainingQuantity,
		print_roll_quantity: printRollQuantity,
		print_metr: remainingQuantity,
		print_sq_m: sqM,
		print_total_price: totalPrice,
	}
}

function Cheque80({ data = { products: [] }, printChequeRef, show = false }) {
	const { t } = useTranslation()

	const [products, setProducts] = useState([]);
	const [accessories, setAccessories] = useState([]);
	const [tunikofons, setTunikofons] = useState([]);
	const [profs, setProfs] = useState([]);
	const [totalAmount, setTotalAmount] = useState({
		accessoryTotalQuantity: 0,
		productsTotalPrice: 0,
		productsTotalQuantity: 0,
	});

	useEffect(() => {
		const productsData = data?.products || [];

		const type1 = [];
		const accessory = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};
		const tunikofon = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};
		const prof = {
			children: [],
			preparedChildren: [],
			totalQuantity: 0,
			totalPrice: 0,
		};

		const newTotalAmount = {
			productsTotalPrice: 0,
			productsTotalQuantity: 0,
		};

		productsData.forEach(product => {
			const printProduct = getPrintProduct(product);
			if (printProduct.print_quantity <= 0) return;

			if (product.product_type === 1) {
				type1.push(printProduct);
				newTotalAmount.productsTotalQuantity += printProduct.print_quantity;
				newTotalAmount.productsTotalPrice += printProduct.print_total_price;
			} else if (product.product_type === 3) {
				if (product.is_prepared) {
					accessory.preparedChildren.push(printProduct);
					accessory.totalQuantity += printProduct.print_quantity;
				} else {
					accessory.children.push(printProduct);
					accessory.totalQuantity += printProduct.print_metr;
				}
				accessory.totalPrice += printProduct.print_total_price;
			} else if (product.product_type === 5) {
				if (product.is_prepared) {
					tunikofon.preparedChildren.push(printProduct);
					tunikofon.totalQuantity += printProduct.print_quantity;
				} else {
					tunikofon.children.push(printProduct);
					tunikofon.totalQuantity += printProduct.print_sq_m;
				}
				tunikofon.totalPrice += printProduct.print_total_price;
			} else if (product.product_type === 4) {
				if (product.is_prepared) {
					prof.preparedChildren.push(printProduct);
					prof.totalQuantity += printProduct.print_quantity;
				} else {
					prof.children.push(printProduct);
					prof.totalQuantity += printProduct.print_metr;
				}
				prof.totalPrice += printProduct.print_total_price;
			}
		});

		setProducts(type1);
		setProfs(prof);
		setAccessories(accessory);
		setTunikofons(tunikofon);
		setTotalAmount(newTotalAmount);
	}, [data.products]);

	const printTotalAmount =
		data.net_total_amount !== undefined
			? toNumber(data.net_total_amount)
			: toNumber(profs.totalPrice) +
			toNumber(accessories.totalPrice) +
			toNumber(tunikofons.totalPrice) +
			toNumber(totalAmount.productsTotalPrice)
	const paidAmount = data.net_paid !== undefined ? toNumber(data.net_paid) : toNumber(data.paid)
	const chequeDebt = data.net_cheque_debt !== undefined ? toNumber(data.net_cheque_debt) : toNumber(data.cheque_debt)

	return (
		<div className={`${show ? '' : 'd-none'}`}>
			<div className={`cheque print ${show ? 'p-3' : 'print'} ${show ? 'w80mm' : 'w80mm'}`} ref={printChequeRef}>
				<div className="text-center mb-2">
					{data.logo ?
						<img src={`https://backend.tameer.uz/uploads/poses/${data.logo}`}
							style={{ maxWidth: 'none', maxHeight: '100px' }} alt={data.logo} />
						:
						<img src={logo} alt="" />
					}
				</div>

				{data.id &&
					<div className="d-between">
						<h5>№ {data.id}</h5>
						<h5>{formatDate(data.cheque_opened_at, "dd.MM.yyyy HH:mm")}</h5>
					</div>
				}
				<hr />

				<div className="d-between">
					<div>{t('seller')}</div>
					<div>{data.cashier_name}</div>
				</div>
				<div className="d-between">
					<div>{t('phone')}</div>
					<div>{regexPhoneNumber(data.cashier_phone)}</div>
				</div>
				<hr />
				<div className="d-between">
					<div>{t('client')}</div>
					<div>{data.client_name}</div>
				</div>
				<div className="d-between">
					<div>{t('phone')}</div>
					<div>{regexPhoneNumber(data.client_phone)}</div>
				</div>
				{data.courier_login &&
					<div className="d-between">
						<div>{t('courier')}</div>
						<div>{data.courier_name}</div>
					</div>
				}
				{data.delivery_type_id &&
					<div className="d-between">
						<div>{t('delivery_type')}</div>
						<div>{data.delivery_type_name}</div>
					</div>
				}
				{data.address &&
					<div className="d-between">
						<div>{t('address')}</div>
						<div>{data.address}</div>
					</div>
				}
				{data.delivery_date &&
					<div className="d-between">
						<div>{t('delivery_date')}</div>
						<div>{formatDate(data.delivery_date, "dd.MM.yyyy HH:mm")}</div>
					</div>
				}
				{data.note &&
					<div className="d-between">
						<div>{t('note')}</div>
						<div>{data.note}</div>
					</div>
				}
				<hr />

				{profs?.children?.length > 0 && (
					<div className="mb-3">
						<div className="fw-bold border-bottom mb-1 pb-1">{t('profiled_sheeting')}</div>
						{profs.children.map((item, index) => (
							<div key={index} className="mb-2 border-bottom pb-1">
								{/* 1. Название товара на всю ширину */}
								<div className="text-break-spaces">
									<b>{index + 1}. {item.product_name}</b>
								</div>

								{/* 2. Детали под названием */}
								<div className="ms-2 mt-1">
									<div className="d-between">
										<div>{t('roll')}</div>
										<div>{item.element_name}</div>
									</div>

									<div className="d-between small">
										<div>{t('metr')}</div>
										<div>
											{`${formatMoney(item.element_quantity, 3)} * ${formatMoney(item.print_roll_quantity, 3)} = ${formatMoney(item.print_metr, 3)}`}
										</div>
									</div>

									<div className="d-between">
										<div>{t('price')}</div>
										<div>
											{formatMoney(item.sale_price)}
										</div>
									</div>

									<div className="d-between">
										<div>{t('total_amount')}</div>
										<div>
											{formatMoney(item.print_total_price)}
										</div>
									</div>

								</div>
							</div>
						))}
						{/* Итого по секции */}
						<div className="d-flex justify-content-between fw-bold">
							<span>{t('total')}</span>
							<span>{formatMoney(profs.totalPrice)}</span>
						</div>
					</div>
				)}

				{profs?.preparedChildren?.length > 0 && (
					<div className="mt-2">
						<div className="fw-bold border-bottom mb-1 pb-1">{t('prepared_prof')}</div>
						{profs.preparedChildren.map((item, index) => (
							<div key={index} className="mb-2 border-bottom pb-1">
								<div className="text-break-spaces">
									<b>{index + 1}. {item.product_name}</b> <span className="badge border text-dark">R</span>
								</div>

								<div className="ms-2 mt-1">
									<div className="d-between">
										<div>{t('quantity')}</div>
										<div className="text-end">
											{formatMoney(item.print_quantity, 3)}
										</div>
									</div>

									<div className="d-between">
										<div>{t('price')}</div>
										<div className="text-end">
											{formatMoney(item.sale_price)}
										</div>
									</div>

									<div className="d-between fw-bold">
										<div>{t('total_amount')}</div>
										<div>
											{formatMoney(item.print_total_price)}
										</div>
									</div>
								</div>
							</div>
						))}
						<div className="d-flex justify-content-between fw-bold border-top pt-1 mt-1">
							<span>{t('total')}</span>
							<span>{formatMoney(profs.totalPrice)}</span>
						</div>
					</div>
				)}

				{accessories?.children?.length > 0 && (
					<div className="mb-3">
						<div className="fw-bold border-bottom mb-1 pb-1">{t('accessory')}</div>
						{accessories.children.map((item, index) => (
							<div key={index} className="mb-2 border-bottom pb-1">
								{/* 1. Название товара на всю ширину */}
								<div className="text-break-spaces">
									<b>{index + 1}. {item.product_name}</b>
								</div>

								{/* 2. Детали под названием */}
								<div className="ms-2 mt-1">
									<div className="d-between">
										<div>{t('roll')}</div>
										<div>{item.element_name}</div>
									</div>

									<div className="d-between small">
										<div>{t('metr')}</div>
										<div>
											{`${formatMoney(item.element_quantity, 3)} * ${formatMoney(item.print_roll_quantity, 3)} = ${formatMoney(item.print_metr, 3)}`}
										</div>
									</div>

									<div className="d-between">
										<div>{t('price')}</div>
										<div>
											{formatMoney(item.sale_price)}
										</div>
									</div>

									<div className="d-between">
										<div>{t('total_amount')}</div>
										<div>
											{formatMoney(item.print_total_price)}
										</div>
									</div>

								</div>
							</div>
						))}
						{/* Итого по секции */}
						<div className="d-flex justify-content-between fw-bold">
							<span>{t('total')}</span>
							<span>{formatMoney(accessories.totalPrice)}</span>
						</div>
					</div>
				)}

				{accessories?.preparedChildren?.length > 0 && (
					<div className="mt-2">
						<div className="fw-bold border-bottom mb-1 pb-1">{t('prepared_accessory')}</div>
						{accessories.preparedChildren.map((item, index) => (
							<div key={index} className="mb-2 border-bottom pb-1">
								<div className="text-break-spaces">
									<b>{index + 1}. {item.product_name}</b>
								</div>

								<div className="ms-2 mt-1">
									<div className="d-between">
										<div>{t('quantity')}</div>
										<div className="text-end">
											{formatMoney(item.print_quantity, 3)}
										</div>
									</div>

									<div className="d-between">
										<div>{t('price')}</div>
										<div className="text-end">
											{formatMoney(item.sale_price)}
										</div>
									</div>

									<div className="d-between fw-bold">
										<div>{t('total_amount')}</div>
										<div>
											{formatMoney(item.print_total_price)}
										</div>
									</div>
								</div>
							</div>
						))}
						{/* Итого по секции готовых аксессуаров */}
						<div className="d-flex justify-content-between fw-bold border-top pt-1">
							<span>{t('total')}</span>
							<span>{formatMoney(accessories.totalPrice)}</span>
						</div>
					</div>
				)}


				{tunikofons?.children?.length > 0 && (
					<div className="mb-3">
						<div className="fw-bold border-bottom mb-1 pb-1">{t('tunikofon')}</div>
						{tunikofons.children.map((item, index) => (
							<div key={index} className="mb-2 border-bottom pb-1">
								<div className="text-break-spaces">
									<b>{index + 1}. {item.product_name}</b>
								</div>

								<div className="ms-2 mt-1">
									<div className="d-between">
										<div>{t('roll')}</div>
										<div>{item.element_name}</div>
									</div>

									<div className="d-between small">
										<div>{t('metr')}</div>
										<div>
											{`${formatMoney(item.element_quantity, 3)} * ${formatMoney(item.print_roll_quantity, 3)} = ${formatMoney(item.print_metr, 3)}`}
										</div>
									</div>

									<div className="d-between small">
										<div>{t('sq_m')}</div>
										<div>
											{formatMoney(item.print_sq_m, 3)}
										</div>
									</div>

									<div className="d-between">
										<div>{t('price')}</div>
										<div>
											{formatMoney(item.print_metr ? item.print_total_price / item.print_metr : 0)}
										</div>
									</div>

									<div className="d-between">
										<div>{t('total_amount')}</div>
										<div>
											{formatMoney(item.print_total_price)}
										</div>
									</div>

								</div>
							</div>
						))}
						<div className="d-flex justify-content-between fw-bold">
							<span>{t('total')}</span>
							<span>{formatMoney(tunikofons.totalPrice)}</span>
						</div>
					</div>
				)}

				{tunikofons?.preparedChildren?.length > 0 && (
					<div className="mt-2">
						<div className="fw-bold border-bottom mb-1 pb-1">{t('prepared_tunicophone')}</div>
						{tunikofons.preparedChildren.map((item, index) => (
							<div key={index} className="mb-2 border-bottom pb-1">
								<div className="text-break-spaces">
									<b>{index + 1}. {item.product_name}</b>
								</div>

								<div className="ms-2 mt-1">
									<div className="d-between">
										<div>{t('quantity')}</div>
										<div className="text-end">
											{formatMoney(item.print_quantity, 3)}
										</div>
									</div>

									<div className="d-between">
										<div>{t('price')}</div>
										<div className="text-end">
											{formatMoney(item.sale_price)}
										</div>
									</div>

									<div className="d-between fw-bold">
										<div>{t('total_amount')}</div>
										<div>
											{formatMoney(item.print_total_price)}
										</div>
									</div>
								</div>
							</div>
						))}
						{/* Итого по секции готовых аксессуаров */}
						<div className="d-flex justify-content-between fw-bold border-top pt-1">
							<span>{t('total')}</span>
							<span>{formatMoney(tunikofons.totalPrice)}</span>
						</div>
					</div>
				)}

				{products?.length > 0 && (
					<div className="mt-2">
						<div className="fw-bold border-bottom mb-1 pb-1">{t('products')}</div>
						{products.map((item, index) => (
							<div key={index} className="mb-2 border-bottom pb-1">
								<div className="text-break-spaces">
									<b>{index + 1}. {item.product_name}</b>
								</div>

								<div className="ms-2 mt-1">
									<div className="d-between">
										<div>{t('quantity')}</div>
										<div className="text-end">
											{formatMoney(item.print_quantity, 3)}
										</div>
									</div>

									<div className="d-between">
										<div>{t('price')}</div>
										<div className="text-end">
											{formatMoney(item.sale_price)}
										</div>
									</div>

									<div className="d-between fw-bold">
										<div>{t('total_amount')}</div>
										<div>
											{formatMoney(item.print_total_price)}
										</div>
									</div>
								</div>
							</div>
						))}
						{/* Итого по секции готовых аксессуаров */}
						<div className="d-flex justify-content-between fw-bold border-top pt-1">
							<span>{t('total')}</span>
							<span>{formatMoney(totalAmount.productsTotalPrice)}</span>
						</div>
					</div>
				)}

				{/* {products.length > 0 &&
					<div>
						<b>{t('products')}</b>
						<table className="table table-border mt-2">
							<thead>
								<tr>
									<th style={{ width: '40%' }}>{t('name2')}</th>
									<th style={{ width: '10%' }} className="text-end">{t('quantity')}</th>
									<th style={{ width: '20%' }} className="text-end">{t('price')}</th>
									<th style={{ width: '35%' }} className="text-end">{t('total_amount')}</th>
								</tr>
							</thead>
							<tbody>
								{products?.map((item, index) => (
									<tr key={index}>
										<td>{item.product_name}</td>
										<td className="text-end">{item.quantity}</td>
										<td className="text-end">{formatMoney(item.sale_price)}</td>
										<td className="text-end">{formatMoney(item.total_price)}</td>
									</tr>
								))
								}
								<tr className="tr-bold">
									<td>{t('total')}</td>
									<td className="text-end">{formatMoney(totalAmount.productsTotalQuantity, 3)}</td>
									<td></td>
									<td className="text-end">{formatMoney(totalAmount.productsTotalPrice)}</td>
								</tr>
							</tbody>
						</table>

					</div>
				} */}
				<hr />

				<div className="mb-2">
					<div className="d-center gap-3 fw-600 fz-20">
						<div>{t('to_pay')}</div>
						<div>{formatMoney(printTotalAmount)}</div>
					</div>
					<hr />

					<div className="d-between gap-2">
						<div>{t('discount')}:</div>
						<div className="text-end" style={{ width: '140px' }}>
							{formatMoney(data?.discount_amount)}
						</div>
					</div>
					<div className="d-between gap-2">
						<div>{t('paid')}:</div>
						<div className="text-end" style={{ width: '140px' }}>
							{formatMoney(paidAmount)}
						</div>
					</div>
					{toNumber(data.total_returned_amount) > 0 &&
						<div className="d-between gap-2">
							<div>{t('return')}:</div>
							<div className="text-end text-danger" style={{ width: '140px' }}>
								- {formatMoney(data.total_returned_amount)}
							</div>
						</div>
					}

					<hr />
					<div className="d-between">
						<div>{t('order_debt')}</div>
						<div className="text-end" style={{ width: '130px' }}>
							{formatMoney(chequeDebt)}
						</div>
					</div>

					{data.status === 3 ?
						<>
							<div className="d-between">
								<div>{t('previous_debt')}</div>
								<div className="text-end" style={{ width: '130px' }}>
									{formatMoney(-data.client_balance + chequeDebt)}
								</div>
							</div>

							<div className="d-between">
								<div>{t('total_debt')}</div>
								<div className="text-end" style={{ width: '130px' }}>
									{formatMoney(-data.client_balance)}
								</div>
							</div>
						</>
						:
						<>
							<div className="d-between">
								<div>{t('previous_debt')}</div>
								<div className="text-end" style={{ width: '130px' }}>
									{formatMoney(-data.client_balance)}
								</div>
							</div>

							<div className="d-between">
								<div>{t('total_debt')}</div>
								<div className="text-end" style={{ width: '130px' }}>
									{formatMoney(-data.client_balance + chequeDebt)}
								</div>
							</div>
						</>

					}
					<hr />
				</div>
			</div>
		</div>
	)
}

export default Cheque80